function authHeader() {
    const token = localStorage.getItem("rouzo2.0_token");
  
    if (token) {
      return token;
    } else {
      return null;
    }
  }
  
  export default authHeader;
  